module.exports = __webpack_public_path__ + "img/4.620631df.png";